//import { combineReducers } from "redux";

import actions from "./actions.js";

const defaultState = {
  loading: null,
  result: null,
  error: null
};

const userInfo = (state = defaultState, action) => {

  switch (action.type) {
    case actions.SET_USER_OBJECT:
      return Object.assign({}, state, {
        loading: true,
        result: action.data,
        error: null
      });
      case actions.SET_USER_LOADING:
        return Object.assign({}, state, {
          loading: true,

        });
        case actions.SET_USER_LOADING_OFF:
          return Object.assign({}, state, {
            loading: false,

          });

    default:
      return state;
  }
};


export default userInfo;
